import React, { useContext, useImperativeHandle, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from 'semantic-ui-react'
import { IRequestInformation } from '../../../models/Enquiry'
import Conditional from '../../common/Conditional'
import EnquiryContext from '../context/EnquiryContext'
import EnquiryRequestForInformationForm from './EnquiryRequestForInformationForm'
import EnquiryRequestForInformationRow from './EnquiryRequestForInformationRow'

export interface IEnquiryRequestForInformationTableProps {
  data: IRequestInformation[]
  handleErrors?: (any) => void
}

const EnquiryRequestForInformationTable = React.forwardRef(
  (props: IEnquiryRequestForInformationTableProps, ref) => {
    const history = useHistory()
    const context = useContext(EnquiryContext)
    const [form, setForm] = useState({
      visible: false,
      data: null,
    })

    useImperativeHandle(ref, () => ({
      clear() {
        setForm((prevState) => ({
          ...prevState,
          data: null,
          visible: false,
        }))
      },
    }))

    const displayForm = (requestForInformation: IRequestInformation) => {
      setForm((prevState) => ({
        ...prevState,
        data: requestForInformation,
        visible: true,
      }))
    }

    const close = () => {
      setForm((prevState) => ({
        ...prevState,
        visible: false,
      }))
    }

    const backtoEnquiries = () => {
      history.push('/my-account/enquiries')
    }
    return (
      <>
        <Conditional if={context.enquiry && !form.visible}>
          <div className="table-wrapper">
            <table id="table-requestinfo">
              <thead>
                <tr>
                  <th>Subject</th>
                  <th>Responded</th>
                  <th>Date requested</th>
                </tr>
              </thead>
              <tbody>
                {context.enquiry?.requestInformation?.map((item, index) => {
                  return (
                    <EnquiryRequestForInformationRow
                      key={index}
                      item={item}
                      displayForm={displayForm}
                    />
                  )
                })}
              </tbody>
            </table>
          </div>
          <Button className="is-primary" onClick={() => backtoEnquiries()}>
            Return to enquiry list
          </Button>
        </Conditional>
        <Conditional if={form.visible}>
          <EnquiryRequestForInformationForm
            data={form.data}
            close={close}
            handleErrors={props.handleErrors}
          />
        </Conditional>
      </>
    )
  }
)
EnquiryRequestForInformationTable.displayName =
  'EnquiryRequestForInformationTable'
export default EnquiryRequestForInformationTable
